import API from "./index";

class InventarioAnualService {
  constructor() {
    this.path = `/api/inventarios-anual`;
  }

  buscarInventarioPorAnoEDepartamento(ano, departamentoId, pageable) {
    return API.get(`${this.path}/buscar-paginado`, {
      params: { ano, departamentoId, ...pageable },
    });
  }

  listarTodos() {
    return API.get(this.path);
  }

  buscarPorId(id) {
    return API.get(`${this.path}/${id}`);
  }

  criarInventario(inventario) {
    return API.post(this.path, inventario);
  }

  atualizarInventario(id, inventario) {
    return API.put(`${this.path}/${id}`, inventario);
  }

  deletarInventario(id) {
    return API.delete(`${this.path}/${id}`);
  }
}

export default new InventarioAnualService();
